import React from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";


const Header = ({ handleLogout }) => { 
  const location = useLocation();
  // Get user from localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const formTitles = { 1: "Orders", 2: "Customer Credit", 3: "Billing", 4: "Crate Ledger", 5: "Purchase Orders", 6: "Cash Float", 7: "Financial Report", 8: "Add-on Revenue", 9: "Statistics", 10: "Cash Management Analytics", 11: "Bill Info" };
  const formId = location.pathname.match(/^\/form\/(\d+)/)?.[1];
  const pageTitle = location.pathname === "/dashboard" ? "Dashboard" : formTitles[formId] || "Application";

  return (
    <div className="header">
      <div className="title"><span className="h5 mb-0">{pageTitle}</span></div>
      <div className="user-info">
        {user && (
          <span className="username" style={{ fontSize: "14px", marginRight: "10px" }}>
            {user.name} {/* Display logged-in user's name */}
          </span>
        )}
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </div>
    </div>
  );
};

export default Header;
